import React from "react";
import { WizeCareWhiteLogo } from "../../../../assets/svg/onboard-icons";

const WizardTopbar = () => (
  <div className="clinician-onboard-card__logo">
    <div className="clinician-onboard-topbar__logo-pill">
      <WizeCareWhiteLogo />
    </div>
  </div>
);

export default WizardTopbar;
